export const digiQNetworks = [
    {label: "AQISS", value: "aqiss"},
    {label: "AQT", value: "aqt"},
    {label: "EFEQT", value: "efeqt"},
    {label: "NQC", value: "nqc"},
]